/**
 * @fileoverview Provides type definitions and a universal parser loader for tree-sitter, supporting both native and web environments. Handles conditional import of tree-sitter based on the runtime context, enabling cross-platform compatibility for syntax parsing.
 */

import type * as TreeSitter from 'tree-sitter'
import type * as WebTreeSitter from 'web-tree-sitter'

export namespace Parser {
  export type SyntaxNode = TreeSitter.SyntaxNode | WebTreeSitter.SyntaxNode
  export type Tree = TreeSitter.Tree | WebTreeSitter.Tree
}

// Branch between the native and web versions of tree-sitter. IDE is electron -> web and CLI is native.
export const Parser =
  typeof window !== 'undefined' ? require('web-tree-sitter') : require('tree-sitter')
